import React, { Fragment } from 'react'
import { Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux'
import { v4 as uuidv4 } from 'uuid';
import { obtenerUsuariosOCNacional } from '../../../redux/DuckOrganismoCertificacion/GenerarUsuariosDuck';
import { actualizarFC01_OCAccion, agregarFC01_OCAccion } from '../../../redux/DuckOrganismoCertificacion/SolicitudesFC01_OCDuck';
import { obtenerSolicitudesFC01RevicionNacionalAdmin, obtenerSolicitudesFC01RevisionNacionalAuxiliar, obtenerSolicitudesUIFC01EstatusAdminRecibidas, obtenerSolicitudesUIFC01EstatusAuxiliarRecibidas } from '../../../redux/DuckOrganismoCertificacion/EstatusSolicitudesUIF01Duck';
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 800,
    height: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
const style1 = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    height: 'fit-content',
    bgcolor: 'background.paper',
    border: 'px solid #000',
    boxShadow: 3,
    p: 3,
    opacity: 1,
    borderRadius: '5px'
};
import { useHistory } from 'react-router-dom';
import { actualizarSolicitud, actualizarSolicitudes, obtenerDatosLogin } from '../../../redux/DucksAtencionACliente/AtencionAClienteDucks';
import { obtenerSolicitudesACDireccion } from '../../../redux/DuckDireccionGerente/DireccionGerenteDuck';
function ModalRevisorComponent(props) {
    const history = useHistory();
    const data = props?.data
    const dispatch = useDispatch()
    const usuarios = useSelector(store => store.GenerarUsuarios.usuarios)
    const [openModal, setOpenModal] = React.useState(true);
    const dataUser = useSelector(store => store.Usuario.user)

    const datosRevisores = useSelector(store => store.AtencionSolicitud.revisores)

    const handleCloseModal = () => {
        setOpenModal(false)
        props.setOpenModalRevisor(false)
    }
    React.useEffect(async () => {
        await dispatch(obtenerDatosLogin())
    }, [])

    const theme = createTheme({
        palette: {
            primary: {
                main: "#EDB75A"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });

    const [openModalAdv, setOpenModalAdv] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const [nombreRevisor, setNombreRevisor] = React.useState('')
    const handleOpenModal = (params) => {
        setTitleModal('Advertencia')
        setNombreRevisor(params.row.Nombre)
        setBodyModal('¿Esta seguro que desea asignar a ' + params.row.Nombre + ' la solicitud ' + props?.dataRevisor.folio + '?')
        // setAccion(data.accion)
        setOpenModalAdv(true)

    }
    const handleCloseModalAdv = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModalAdv(false)
    }

    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModalAdv}
                    onClose={handleCloseModalAdv}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style1}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>{titleModal}</center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            {bodyModal} <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row'>
                            <div className='col-md-2'>
                                <button className='btn btn-success' onClick={() => { botonGuardar() }}>GUARDAR</button>
                            </div>
                            <div className='col-md-3 ms-5'></div>
                            <div className={`col-md-2`}>
                                <button className='btn btn-danger' onClick={() => { handleCloseModal() }}>CANCELAR</button>
                            </div>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }

    async function botonGuardar() {
        if (props?.dataRevisor?.tipoSolicitud === 'Solicitud de inscripción') await dispatch(actualizarSolicitud({ data: { idSolicitud: props?.dataRevisor?.idSolicitud, nombreRevisor } }))

        if (props?.dataRevisor?.tipoSolicitud === 'Solicitud de venta nacional') {
            let data = { tabla: 'fc_33_solicitudenvasadonacional', id: props?.dataRevisor?.idSolicitud, idname: 'idfc33_solicitudenvasadonaciona', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        if (props?.dataRevisor?.tipoSolicitud === 'Solicitud de certificado NOM para exportación') {
            let data = { tabla: 'fc_09_solicitudemicioncertificadonomexportacionyentregahologram', id: props?.dataRevisor?.idSolicitud, idname: 'idfc09_solicitudcertificado', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        if (props?.dataRevisor?.tipoSolicitud === 'Solicitud de traslado de producto') {
            let data = { tabla: 'fc_30_notificaciontrasladodeproducto', id: props?.dataRevisor?.idSolicitud, idname: 'idfc30_notificaciontrasladodepr', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        if (props?.dataRevisor?.tipoSolicitud === 'Solicitud de uso marca e imagen COMERCAM') {
            let data = { tabla: 'fc_05_solicitudusomarcaeimagen', id: props?.dataRevisor?.idSolicitud, idname: 'idfc05_solicitudusomarcaeimagen', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        if (props?.dataRevisor?.tipoSolicitud === 'Solicitud de servicios varios') {
            let data = { tabla: 'fc_35_notificaciondeserviciosvarios', id: props?.dataRevisor?.idSolicitud, idname: 'idfc35_notificacionserviciosvar', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        if (props?.dataRevisor?.tipoSolicitud === 'Solicitud de registro de maguey') {
            let data = { tabla: 'fc_06_registrodemaguey', id: props?.dataRevisor?.idSolicitud, idname: 'idfc06_registromaguey', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        if (props?.dataRevisor?.tipoSolicitud === 'Solicitud de renovación de certificados') {
            let data = { tabla: 'fc_08_solicitudrenvacioncertificados', id: props?.dataRevisor?.idSolicitud, idname: 'idfc08_renvacioncertificado', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        if (props?.dataRevisor?.tipoSolicitud === 'Solicitud de compra de hologramas') {
            let data = { tabla: 'fc_40_solicituddeadquisiciondehologramas', id: props?.dataRevisor?.idSolicitud, idname: 'idfc40_solicitudadquisicionholo', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        if (props?.dataRevisor?.tipoSolicitud === 'Notificación suspensión y reactivación') {
            let data = { tabla: 'fc_34_notificacionsuspencionyreactivacion', id: props?.dataRevisor?.idSolicitud, idname: 'idfc34_notificacionsuspencion', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        if (props?.dataRevisor?.tipoSolicitud === 'Solicitud para productos con mezcal') {
            let data = { tabla: 'fc_41_solicitudparabebidasconmezcal', id: props?.dataRevisor?.idSolicitud, idname: 'idfc41_solicitudparabebidasconm', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        if (props?.dataRevisor?.tipoSolicitud === 'Solicitud de seguimiento') {
            let data = { tabla: 'fc_31_solicitudseguimiento', id: props?.dataRevisor?.idSolicitud, idname: 'idfc31_solicitudseguimiento', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        if (props?.dataRevisor?.tipoSolicitud === 'fc_36_solicituddeactualizacion' || props?.dataRevisor?.tipo=='Solicitud de actualización') {
            let data = { tabla: 'fc_36_solicituddeactualizacion', id: props?.dataRevisor?.idSolicitud, idname: 'idfc36_solicitudactualizacion', revisor: nombreRevisor }
            await dispatch(actualizarSolicitudes(data))
        }
        handleCloseModal()
        handleCloseModalAdv()

        if (props?.dataRevisor?.estatus == 'Recibida en AC') {
            await dispatch(obtenerSolicitudesACDireccion(2))
        }
        if (props?.dataRevisor?.estatus == 'En Revisión Por AC') {
            await dispatch(obtenerSolicitudesACDireccion(3))
        }
        if (props?.dataRevisor?.estatus == 'Aceptada Por AC') {
            await dispatch(obtenerSolicitudesACDireccion(4))
        }
        if (props?.dataRevisor?.estatus == 'Devuelta al cliente para corrección') {
            await dispatch(obtenerSolicitudesACDireccion(5))
        }
        if (props?.dataRevisor?.estatus == 'Recibida corregida por el cliente') {
            await dispatch(obtenerSolicitudesACDireccion(6))
        }
        history.push('/SolicitudesACDireccion')
    }



    const rowsRevisores = [];
    datosRevisores?.map(revisor => {
        rowsRevisores.push(
            {
                id: uuidv4(), Nombre: revisor.datoslogin.nombre + ' ' + revisor.datoslogin.apellidos,
                Telefono: revisor.datoslogin.telefono, Correo: revisor.usuario, Cartera: revisor.datoslogin.cartera,
                nombreRevisor: revisor.datoslogin.nombre, apellidosRevisor: revisor.datoslogin.apellidos,
            },
        )
    })
    const columnsRevisores = [

        { field: 'Nombre', headerAlign: 'center', headerName: 'Nombre Completo', width: 250 },
        {
            field: 'accion', headerAlign: 'center', headerName: 'Acción', width: 250,
            renderCell: (params) => (
                <>
                    <button onClick={() => handleOpenModal(params)} className={`btn btn-outline-warning`} >Asignar</button>

                </>
            )

        }
    ]




    return (
        <Fragment>
            <Modal open={openModal} onClose={handleCloseModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h4" component="h2" className='text-center'>
                        Asignación de ejecutivas(os)
                    </Typography>
                    <div className='row justify-content-center'>
                        <div className='col-8 bg-white'>
                            <div style={{ height: 450, width: '105%' }}>
                                <DataGrid
                                    rows={rowsRevisores}
                                    columns={columnsRevisores}
                                    pageSize={6}
                                    rowsPerPageOptions={[7]}
                                    sx={{
                                        boxShadow: 0,
                                        color: 'black',
                                        border: 0,
                                        fontFamily: 'Montserrat',
                                        '& .MuiDataGrid-cell': {
                                            display: 'block',
                                            position: 'relative',
                                            textAlign: 'center',
                                            paddingTop: '10px',
                                            paddingBottom: '15px'
                                        },
                                        '& .MuiDataGrid-columnHeaders': {
                                            backgroundColor: '#0C365A',
                                            color: 'white',
                                            fontFamily: 'Montserrat',
                                            fontWeight: 'bold',
                                            height: '20px'
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <ThemeProvider theme={theme}>
                        <div className='col-12 col-md-12 d-flex justify-content-center'>
                            <Button variant="contained" color="secondary" style={{ width: '50%' }} onClick={() => { handleCloseModal() }}>Cerrar</Button>
                        </div>
                    </ThemeProvider>
                </Box>
            </Modal>
            {modalComponent()}
        </Fragment>
    )
}
export default ModalRevisorComponent